import { createSanitizationProfile } from '../../createSanitizationProfile/createSanitizationProfile';

/**
 * Represents the plain text sanitization profile.
 *
 * This doesn't allow any tags - hence we set the fields to empty values. See
 * https://github.com/apostrophecms/sanitize-html#what-if-i-dont-want-to-allow-any-tags
 */
export const plainTextSanitizationProfile = createSanitizationProfile({
  allowedTags: [],
  allowedAttributes: {},
});
